// extracted by mini-css-extract-plugin
export default {"root":"TextOnly__root--m78Ud","dark":"TextOnly__dark--PmibQ"};